import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { useCallback, useEffect, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup"
import { useTranslation } from "react-i18next";
import TextBox from "../../../components/controls/form/TextBox";
import User from "../../../services/user";
import PubSub from "../../../services/PubSub";
import { useAppContext } from "../../../common/ApplicationServicesContext";

const UserSettingsModal = ({ id, show, onCancel }) => {
    const { refreshUser } = useAppContext();
    const [userDetails, setUserDetails] = useState({});
    const [showSaveButton, setShowSaveButton] = useState(false);

    const [translate] = useTranslation();

    const getUser = useCallback(async () => {
        const response = await User.getUser();
        if (response && !response.error) {
            setUserDetails({ ...response.data });
        }
        setShowSaveButton(false);
    }, []);

    const updateUser = useCallback(async ({ firstName, lastName }) => {
        const updatedObj = {
            firstName,
            lastName
        }

        const response = await User.updateUser(id, updatedObj);
        if (response && !response.error) {
            await refreshUser();
            PubSub.publish("refresh-user-list");
            onCancel();
        }
    }, [id, onCancel, refreshUser]);

    useEffect(() => {
        if (id && show) {
            getUser(id);
        }
        else {
            setUserDetails({});
        }
    }, [id, show, getUser]);

    return <Formik
        key={show ? "modal-open" : "modal-closed"}
        initialValues={{
            firstName: userDetails.firstName || "",
            lastName: userDetails.lastName || "",
            email: userDetails.email || ""
        }}
        validationSchema={Yup.object({
            email: Yup.string().email(translate("OTM_INVALID_EMAIL")).required(translate("OTM_EMAIL_REQUIRED")),
            firstName: Yup.string().required(translate("OTM_YUP_FIRST_NAME_REQUIRED")),
            lastName: Yup.string().required(translate("OTM_YUP_LAST_NAME_REQUIRED")),
        })}
        onSubmit={updateUser}
        enableReinitialize
    >
        <BootstrapModal show={show} backdrop="static">
            <BootstrapModal.Header className="h5 text-secondary">{translate("OTM_USER_DETAILS")}</BootstrapModal.Header>
            <BootstrapModal.Body>
                <Form id="userSettings" onChange={() => { setShowSaveButton(true) }}>
                    <TextBox label={translate("OTM_FIRST_NAME")} isRequired type="text" name="firstName" />
                    <TextBox label={translate("OTM_LAST_NAME")} isRequired type="text" name="lastName" css="mt-3" />
                    <TextBox label={translate("OTM_EMAIL")} isRequired type="email" name="email" disabled css="mt-3" />
                </Form>
            </BootstrapModal.Body>
            <BootstrapModal.Footer>
                {showSaveButton && <Button form="userSettings" type="submit" className="btn-sm">{translate("OTM_SAVE")}</Button>}
                <Button onClick={onCancel} variant="secondary" className="btn-sm">{translate("OTM_CANCEL")}</Button>
            </BootstrapModal.Footer>
        </BootstrapModal>
    </Formik>
};

export default UserSettingsModal;